"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOnClose = void 0;
var utils_1 = require("../../utils/utils");
var SelectOnClose = function (target) {
    return /** @class */ (function (_super) {
        __extends(SelectOnClose, _super);
        function SelectOnClose() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SelectOnClose.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            select.on('close', function (event) {
                _this._handleSelectOnClose(event);
            });
        };
        SelectOnClose.prototype._handleSelectOnClose = function (params) {
            if (params && params.originalSelect2Event != null) {
                var event_1 = params.originalSelect2Event;
                // Don't select an item if the close event was triggered from a select or
                // unselect event
                if (event_1._type === 'select' || event_1._type === 'unselect') {
                    return;
                }
            }
            var highlightedResults = this.getHighlightedResults();
            // Only select highlighted results
            if (highlightedResults.length === 0) {
                return;
            }
            var data = utils_1.Utils.GetData(highlightedResults[0], 'data');
            // Don't re-select already selected resulte
            if ((data.element != null && data.element.selected) ||
                (data.element == null && data.selected)) {
                return;
            }
            this.trigger('select', {
                data: data
            });
        };
        return SelectOnClose;
    }(target));
};
exports.SelectOnClose = SelectOnClose;
//# sourceMappingURL=select-on-close.js.map